import { formatDayMonth } from "../lib/format.ts";
import type { CatalogueResponse } from "../lib/api.ts";

/**
 * The site-wide offer, as a gold band under the photograph.
 *
 * Said once, here, rather than badged on every treatment: each price below
 * already has it applied, so this explains them rather than promising something
 * further off. Nothing renders when there is no offer running.
 */
export function OfferBand({
  offer,
}: {
  offer: CatalogueResponse["siteWideOffer"] | undefined;
}) {
  if (!offer) return null;

  const newClientOffer = offer.label.trim().toLowerCase() === "new client special";
  const descriptor = offer.descriptor.replace(/(£\d+)\.00\b/g, "$1");

  return (
    <aside className="offer-band" aria-label="Current offer">
      {!newClientOffer && <p className="offer-band__label">{offer.label}</p>}
      <p className={newClientOffer ? "offer-band__detail offer-band__detail--new-client" : "offer-band__detail"}>
        {newClientOffer ? `New clients: ${descriptor} your first treatment` : `${descriptor} every treatment`}
        {offer.endsOnDate && (
          <> until {formatDayMonth(`${offer.endsOnDate}T12:00:00Z`, false)}</>
        )}
      </p>
    </aside>
  );
}
